import { useCallback } from 'react';
import { useAuth } from '@/shared/context/AuthContext';
import {
  expandLegacyPermissions,
  userHasAnyPermission as checkAnyPermission,
  userHasPermission as checkPermission,
} from '@/shared/constants/leaveSchedulingPermissions';

export const usePermission = () => {
  const { user } = useAuth();

  const hasPermission = useCallback((permission: string): boolean => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    return checkPermission(user.permissions, permission);
  }, [user]);

  const hasAnyPermission = useCallback((permissions: string[]): boolean => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    return checkAnyPermission(user.permissions, permissions);
  }, [user]);

  const expandedPermissions = useCallback((): string[] => {
    if (!user) return [];
    if (user.role === 'admin') return [];
    return expandLegacyPermissions(user.permissions);
  }, [user]);

  return { hasPermission, hasAnyPermission, expandedPermissions };
};
